import React from 'react';
import SDK from '../../SDK';
import { getFromLocalStorageAndDecrypt, encryptAndStoreInLocalStorage, deleteItemFromLocalStorage} from '../../Helpers/Chat/webChatEncryptDecrypt';
import { PERMISSION_DENIED } from '../../processENV';
import { toast } from 'react-toastify';
import { store } from '../../Redux/store';
import { muteLocalVideo } from "../../callback";
import FloatingCallOption from './FloatingCallOption/FloatingCallOption';
import { ArrowBackHoc, EmptyCallLogHoc, FloatingCallActionSmHoc, loaderSVG } from '../../assets/images';
import NewParticipants from '../WebChat/NewGroup/NewParticipants';
import Search from './CallLogs/Search';
import { formatUserIdToJid, getDataFromRoster, getLocalUserDetails, getUserDetails, initialNameHandle } from '../../Helpers/Chat/User';
import { addShowConfrenceData } from '../../Redux/feature/showConfrenceDataSlice';
import { addCallConnectionDate } from '../../Redux/feature/callConnectionDateSlice';
import { NO_INTERNET } from '../../Helpers/Constants';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter, getFormatPhoneNumber, getPhoneNumberFromJid, getUserIdFromJid, isConnStateEqualTo } from '../../Helpers/Utility';
import { displayNameFromRencentChat, handleParticipantList } from '../../Helpers/Chat/ChatHelper';
import { getGroupData } from '../../Helpers/Chat/Group';
import CallLogView from './CallLogs/CallLogView';
import InfiniteScroll from 'react-infinite-scroll-component';
import callLogsObj from '../WebCall/CallLogs/callLog';
import { COMMON_ERROR_MESSAGE } from '../../Helpers/Call/Constant';
import { hideModal, showModal } from '../../Redux/feature/popUpDataSlice';
import { startCallingTimer } from '../../Helpers/Call/Call';
import { CONNECTION_STATE_CONNECTING, CONNECTION_STATE_CONN_FAILED, CONNECTION_STATE_ERROR_OCCURED } from '../../Helpers/Chat/Constant';
import { isUserWhoBlockedMe } from '../../Helpers/Chat/BlockContact';

const WebChatCallLogs = (props = {}) => {

    const stateData = useSelector((state) => state)
    const callLogData = useSelector((state) => state.callLogData.data);
    const rosterData = useSelector((state) => state.rosterData);
    const appOnlineStatus = useSelector((state) => state.appOnlineStatus);
    const { isAppOnline = false} = appOnlineStatus
    const { groupsData : { data = [] , id} = {} } = stateData ;

    const [chatCall, setChatCall] = React.useState({
        loaderStatus: !!callLogData.isFetchingCallLog,
        searchterm: "",
        callLogs: [],
        newCall: false,
        newCallType: "video",
        currentGroupID: "",
    });

    const { 
        loaderStatus,
        searchterm,
        callLogs,
        newCall,
        newCallType,
        currentGroupID,
        // searchValue,
        // errorMesage,
        // filteredContacts,
        // userList,
    } = chatCall;

    let preventMultipleClick = false;

    const getCallLogs = () => {
        const { callLogs: callLogsObjData, isFetchingCallLog } = callLogData;
        if (isFetchingCallLog) {
            return [];
        }
        return Object.values(callLogsObjData);
    }

    const setCallLogElement = () => {
        if (callLogData.isFetchingCallLog) {
            setChatCall({ 
                ...chatCall,
                loaderStatus: callLogData.isFetchingCallLog });
            return;
        }
        let callLogsArr = getCallLogs();
        callLogsArr = callLogsArr.sort(function (a, b) {
            return a.callTime - b.callTime
        })
        callLogsArr.reverse();
        setChatCall({...chatCall, callLogs: callLogsArr, loaderStatus: false });
    }

    /**
     * handleOnBack() method to manage the back to recent chat icon click status.
     */
    const handleOnBack=()=> {
        props.handleBackStatus(true);
    }

    /**
     * handleCallLogs() method is perform to render the call logs ui.
     */
    const handleCallLogs = (callLogsNew) => {
        let callLogsArray = callLogsNew || callLogs;
        let dataArr = [];
        if (callLogsArray.length > 0) {
            let searchtermData = chatCall.searchterm;
            let vcardData = getLocalUserDetails();
            let currentUser = vcardData && vcardData.fromUser;
            const roomId = getFromLocalStorageAndDecrypt('roomName');
            callLogsArray.map((callLog, index) => {
                let displayName = "";
                let isAdminBlocked = "0";
                let initialName = "";
                let deletedUser = [];
                let userId = "";
                let image = "",
                emailId = "";
                // Prevent the current call calllog display.
                if (roomId === callLog.roomId) return;
                if (callLog) {
                    let userListArr = (callLog.userList && callLog.userList.split(',')) || [];
                    /**
                    // if(callLog.userList === ""){
                        //     callLogsObj.getCallLogsFromServer(1)
                        // }
                        */
                        const userListLength = userListArr.length;
                        userListArr = getUserListWithFromUser(callLog);
                        userListArr.map((user) => {
                            const phoneNumber = getUserIdFromJid(user);
                            let roster = getUserDetails(phoneNumber);
                            if (phoneNumber !== currentUser && currentUser) {
                            if (roster) {
                                let name = displayNameFromRencentChat(roster) || getFormatPhoneNumber(phoneNumber);
                                displayName = displayName ? `${displayName}, ${name}` : name;
                                initialName = initialNameHandle(roster, displayName);
                                if(callLog.callMode === "onetomany") {
                                    isAdminBlocked = false;
                                }else {
                                    isAdminBlocked = roster.isAdminBlocked;
                                }
                                deletedUser.push(roster.isDeletedUser ? true : false);
                                image = userListLength > 1 ? "" : roster.thumbImage !== "" ? roster.thumbImage : roster.image;
                                userId = roster.userId
                                emailId = roster.emailId
                            } else {
                                displayName = getFormatPhoneNumber(getUserIdFromJid(user));
                                image = "";
                            }
                        } else {
                            deletedUser.push(true);
                        }
                    });
                }
                let isDeletedUser = !deletedUser.includes(false);
                if (callLog && callLog.callMode === "onetomany" && callLog.groupId) {
                    const groupId = callLog.groupId.split('@mix')[0];
                    const group = getGroupData(groupId);
                    if (group) {
                        displayName = group.groupName;
                        image = group.thumbImage !== "" ? group.thumbImage : group.groupImage;
                        isAdminBlocked = group.isAdminBlocked
                    }
                }
                
                if (displayName !== "") {
                    if (displayName.toLowerCase().includes(searchtermData)) {
                        dataArr.push(
                            <CallLogView
                                key={`${callLog.roomId}-${index}`}
                                displayName={displayName}
                                image={image}
                                searchterm={searchtermData}
                                callLog={callLog}
                                makeCall={prepareForCall}
                                emailId={emailId}
                                initialName={initialName}
                                isAdminBlocked={isAdminBlocked}
                                isDeletedUser={isDeletedUser}
                                userId={userId}
                                userBlocked={isUserWhoBlockedMe(userId)}
                            />
                        )
                    }
                }
            });
        }
        return dataArr;
    }

    /**
     * handleFilterCallLogsList() method is to handle the searched call log from list
     *
     * @param {string} searchterm
     */
    const handleFilterCallLogsList = (searchtermList) => {
        setChatCall({ 
            ...chatCall,
            searchterm: searchtermList.trim().toLowerCase() })
    }

    const closePopup = () => {
        store.dispatch(hideModal());
    }

    const makeCall = async (callMode, callType, groupCallMemberDetails, groupId = null) => {
        let connectionStatus = getFromLocalStorageAndDecrypt("connection_status")
        if (connectionStatus === "CONNECTED") {
            let users = [], roomId = "", call = null, image = "";
            const vcardData = getLocalUserDetails();
            let fromuser = formatUserIdToJid(vcardData.fromUser);

            if (callMode === "onetoone") {
                users = groupCallMemberDetails;
            } else if (callMode === "onetomany") {
                if (groupCallMemberDetails.length > 0) {
                    groupCallMemberDetails.forEach(function (member) {
                        if (member !== fromuser) {
                            if (typeof member === "object")
                                users.push(member.userJid);
                            else
                                users.push(member);
                        }
                    });
                } else {
                    users = [""];
                }
            }

            let callConnectionStatus = {
                callMode: callMode,
                callStatus: "CALLING",
                callType: callType,
                from: fromuser,
                userList: users.join(","),
            }
            if (callMode === "onetoone") {
                callConnectionStatus.to = users.join(",");
                callConnectionStatus.userAvatar = image;
            } else if (callMode === "onetomany") {
                callConnectionStatus.to = groupId;
                callConnectionStatus.groupId = groupId;
            }
            
            encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callConnectionStatus))
            encryptAndStoreInLocalStorage('callType', callType)
            encryptAndStoreInLocalStorage('callingComponent', true)
            encryptAndStoreInLocalStorage('callFrom', getFromLocalStorageAndDecrypt('loggedInUserJidWithResource'));
            store.dispatch(addCallConnectionDate(callConnectionStatus));
            const showConfrenceData = store.getState().showConfrenceData;
            const {  data: confrenceData } = showConfrenceData
            store.dispatch(addShowConfrenceData({
                localStream: confrenceData?.localStream,
                localVideoMuted: confrenceData?.localVideoMuted,
                localAudioMuted: confrenceData?.localAudioMuted,
                showComponent: true,
                callStatusText: 'Calling'
            }))
            try {
                if (callType === "audio") {
                    muteLocalVideo(true);
                    call = await SDK.makeVoiceCall(users, groupId);
                } else if (callType === "video") {
                    muteLocalVideo(false);
                    call = await SDK.makeVideoCall(users, groupId);
                }
                if (call.statusCode !== 200 && call.message === PERMISSION_DENIED) {
                    deleteItemFromLocalStorage('roomName')
                    deleteItemFromLocalStorage('callType')
                    deleteItemFromLocalStorage('call_connection_status')
                    encryptAndStoreInLocalStorage("hideCallScreen", false);
                    encryptAndStoreInLocalStorage('callingComponent', false)
                    encryptAndStoreInLocalStorage("hideCallScreen", false);
                    store.dispatch(addShowConfrenceData({
                        showComponent: false,
                        showCalleComponent: false,
                        stopSound: true,
                        callStatusText: null
                    }))
                } else {
                    roomId = call.roomId;
                    callLogsObj.insert({
                        "callMode": callConnectionStatus.callMode,
                        "callState": 1,
                        "callTime": callLogsObj.initTime(),
                        "callType": callConnectionStatus.callType,
                        "fromUser": callConnectionStatus.from,
                        "roomId": roomId,
                        "userList": callConnectionStatus.userList,
                        ...(callMode === "onetomany" && {
                            "groupId": groupId
                        })
                    });
                    encryptAndStoreInLocalStorage('roomName', roomId)
                    let callConnectionStatusNew = {
                        ...callConnectionStatus,
                        roomId: roomId
                    }
                    encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callConnectionStatusNew))
                    store.dispatch(addCallConnectionDate(callConnectionStatusNew));
                    startCallingTimer();
                }
            } catch (error) {
                console.log("Error in making call", error);
                if (error.message === PERMISSION_DENIED) {
                    deleteItemFromLocalStorage('roomName')
                    deleteItemFromLocalStorage('callType')
                    deleteItemFromLocalStorage('call_connection_status')
                    encryptAndStoreInLocalStorage("hideCallScreen", false);
                    encryptAndStoreInLocalStorage('callingComponent', false)
                    encryptAndStoreInLocalStorage("hideCallScreen", false);
                    store.dispatch(addShowConfrenceData({
                        showComponent: false,
                        showCalleComponent: false,
                        stopSound: true,
                        callStatusText: null
                    }))
                }
            }
            preventMultipleClick = false;
        } else {
            toast.error(NO_INTERNET)
            preventMultipleClick = false;
        }
    }

    const prepareForCall = async (callLog) => {
        const roomName = getFromLocalStorageAndDecrypt('roomName');
        if (roomName) {
            toast.info("Can't place a new call while you're already in a call.");
            return;
        }
        
        if (preventMultipleClick) {
            return;
        }
        setChatCall({
            ...chatCall,
            currentGroupID : callLog?.groupId.split("@")[0]
        })
        preventMultipleClick = true;
        let connectionStatus = getFromLocalStorageAndDecrypt("connection_status")
        if (connectionStatus === "CONNECTED") {
            const callType = callLog.callType;
            const callMode = callLog.callMode;
            const callUserListArr = getUserListWithFromUser(callLog);
            const callUserNumberArr = callUserListArr.map((user) => user.split('@')[0]);
            const groupMembers = [];
            let groupMemberDetails = [];
            let displayName = null;
            let vcardData = getLocalUserDetails();
            let currentUser = vcardData.fromUser;
            let groupId = '';

            if (callMode === 'onetoone' || callLog.groupId === "" || callLog.groupId === null) {
                callUserNumberArr.map((user) => {
                    const phoneNumber = user.split('@')[0];
                    const userDetails = getUserDetails(phoneNumber);
                    if (phoneNumber !== currentUser && userDetails && !userDetails.isDeletedUser) {
                        groupMembers.push(formatUserIdToJid(phoneNumber));
                        groupMemberDetails.push({ ...userDetails });
                    }
                })
            }
            else {
                groupId = callLog.groupId;
                const { groupsMemberParticipantsListData: { groupParticipants = {} } = {} } = stateData || {}
                let participants = groupParticipants[groupId];
                groupMemberDetails = getGroupMembers(participants)
                groupMemberDetails = sortUsersDisplayName(groupMemberDetails);
                const group = getGroupData(groupId);
                displayName = (group && group.groupName) || displayName;

                groupMemberDetails.map(participant => {
                    const { userJid, username, GroupUser } = participant
                    let user = userJid || username || GroupUser;
                    user = user.split('@')[0];
                    let userDetails = getDataFromRoster(user);
                    if (user !== currentUser && callUserNumberArr.indexOf(user) > -1 && !userDetails.isDeletedUser) {
                        groupMembers.push(formatUserIdToJid(user));
                    }
                });
            }

            if (groupMembers.length === 0) {
                toast.error(COMMON_ERROR_MESSAGE);
                preventMultipleClick = false;
                return false
            } else if (callMode === 'onetoone') {
                makeCall(callMode, callType, groupMembers, groupId);
            }else {
                    store.dispatch(showModal({
                        open: true,
                        modelType: 'calllogparticipants',
                        groupName: displayName,
                        groupMembers: groupMembers,
                        groupuniqueId: groupId,
                        groupMemberDetails: groupMemberDetails,
                        makeGroupCall: callMode === 'onetoone' ? makeOne2OneCall : makeGroupCall,
                        callType: callType,
                        closePopup: closePopup
                    }));
            }
            preventMultipleClick = false;
        } else {
            toast.error(NO_INTERNET)
            preventMultipleClick = false;
        }
        return true;
    }

    const makeOne2OneCall = async (callType, users) => {
        makeCall("onetoone", callType, users);
    }
    /**
    // const showCallParticipants = async (groupId, callType) => {
    //     const groupid = groupId + '@mix.' + REACT_APP_XMPP_SOCKET_HOST;
    //     let connectionStatus = getFromLocalStorageAndDecrypt("connection_status")
    //     if (connectionStatus === "CONNECTED") {
    //         const { groupsMemberParticipantsListData: { groupParticipants = {} } = {} } = props || {}
    //         let participants = groupParticipants[groupid];
    //         let groupMemberDetails = getGroupMembers(participants)
    //         groupMemberDetails = sortUsersDisplayName(groupMemberDetails);
    //         let groupMembers = [];
    //         let group = getGroupData(groupId);
    //         let rosterData = {
    //             displayName: group.groupName,
    //             image: group.groupImage,
    //             jid: groupId,
    //         }
    //         groupMemberDetails.map(participant => {
    //             const { userJid, username, GroupUser } = participant
    //             let user = userJid || username || GroupUser
    //             let currentUser = props?.vCardData?.data?.fromuser;
    //             if (user !== currentUser) {
    //                 groupMembers.push(user)
    //             }
    //         });

    //         if (groupMembers.length === 0) {
    //             toast.error("You are only one member in the group")
    //             preventMultipleClick = false;
    //             return false
    //         } else if (groupMembers.length === 1) {
    //             makeGroupCall(callType, groupMembers);
    //         } 
    //         else {
    //             props.callParticiapants({
    //                 open: true,
    //                 modelType: 'callparticipants',
    //                 groupName: rosterData.displayName,
    //                 groupMembers: groupMembers,
    //                 groupuniqueId: formatUserIdToJid(groupId, CHAT_TYPE_GROUP),
    //                 groupMemberDetails: groupMemberDetails,
    //                 makeGroupCall: makeGroupCall,
    //                 callType: callType
    //             });
    //         }
    //         preventMultipleClick = false;
    //     } else {
    //         toast.error(NO_INTERNET)
    //         preventMultipleClick = false;
    //     }
    // }
    */
    const sortUsersDisplayName = (groupMemberDetails) => {
        return groupMemberDetails.map(member => {
            const { displayName, name, username, jid, GroupUser } = member
            const nameToDisplay = displayName || name || jid || username || getFormatPhoneNumber(GroupUser)
            member.displayName = nameToDisplay
            return member
        }).sort((b, c) => isNaN(parseInt(c.displayName)) - isNaN(parseInt(b.displayName)) || String(b.displayName).localeCompare(String(c.displayName)))
    }

    const makeGroupCall = async (callType, groupCallMemberDetails, groupId) => {
        makeCall("onetomany", callType, groupCallMemberDetails, groupId);
    }

    const getGroupMembers = (participants) => {
        const { rosterData: { data: totalContactList = [] } = {} } = rosterData
        return participants && handleParticipantList(participants, totalContactList) || []
    }

    const getUserListWithFromUser = (callLog) => {
        let userListArr = (callLog.userList && callLog.userList.split(',')) || [];
        userListArr.unshift(callLog.fromUser);
        const filteredUserArr = [];
        // Filter the duplicate phone number
        userListArr.map((userJid) => {
            if (!userJid) return;
            const phoneNumber = getPhoneNumberFromJid(userJid);
            const isUserExist = filteredUserArr.find((uJid) => getPhoneNumberFromJid(uJid) === phoneNumber);
            if (!isUserExist) filteredUserArr.push(userJid);
        });
        return filteredUserArr;
    }
    const handleAudioCall = () => {
        if (props.contactPermission === 0) {
            props.handleContactPermissionPopup(true, NEW_CALL_CONTACT_PERMISSION_DENIED);
            return;
        }
        setChatCall({
            ...chatCall,
            newCall: true,
            newCallType: "audio"
        });
    }

    const handleVideoCall = () => {
        if (props.contactPermission === 0) {
            props.handleContactPermissionPopup(true, NEW_CALL_CONTACT_PERMISSION_DENIED);
            return;
        }
        setChatCall({
            ...chatCall,
            newCall: true,
            newCallType: "video"
        });
    }
    
    const handleBackCallLog = () => {
        setChatCall({
            ...chatCall,
            newCall: false
        })
    }

    const makeNewcall = (callType, usersList) => {
        let callMode = "onetoone";
        let users = [];
        if (usersList.length > 1) {
            callMode = "onetomany";
            users = usersList;
        } else {
            usersList.map(participant => {
                const { userJid, username, GroupUser } = participant
                let user = userJid || username || GroupUser;
                user = user.split('@')[0];
                let userDetails = getDataFromRoster(user);
                if (!userDetails.isDeletedUser) {
                    users.push(formatUserIdToJid(user));
                }
            });
        }
        if (users.length === 1 ) {
            makeCall(callMode, callType, users, "");
        }else if(users.length > 1) {
            makeCall(callMode, callType, users, "");
        }else{
            if(toast.error.length > 1) {
                toast.dismiss();
                // toast.error(FEATURE_RESTRICTION_ERROR_MESSAGE);
            } 
        }
    }

    React.useEffect(()=>{
        setCallLogElement();
    },[])

    React.useEffect(()=>{
        setCallLogElement();
    },[callLogData,searchterm])

    React.useEffect(()=>{
        let currentGroupData = data.find(item => item?.groupId === currentGroupID)
            if(currentGroupData?.isAdminBlocked){
                closePopup()
            }
    },[id])

    const fetchMoreData = () => {
        let callLogsArr = chatCall.callLogs;
        callLogsObj.getCallLogsFromServer(Math.ceil((callLogsArr.length / 20) + 1));
    }

    const callLogArr = handleCallLogs();

    const loaderStyle = {
        width: 80, height: 80
    }
    return (
        <React.Fragment>
            {!newCall ?
                <React.Fragment>
                    <div className="contactlist call-logs">
                        <div className="recent-chatlist-header">
                            <div className="profile-img-name">
                                <i className="newchat-icon" onClick={handleOnBack} title="Back">
                                    <ArrowBackHoc viewBox="0 0 24 24"/>
                                </i>
                                <span>{"Call Logs"}</span>
                            </div>
                        </div>                            
                        {((callLogArr.length > 0 && !searchterm) ||
                                searchterm) &&
                            <Search handleSearchFilterList={handleFilterCallLogsList} />
                        }
                        {(!isAppOnline ||
                        isConnStateEqualTo([
                        CONNECTION_STATE_CONNECTING,
                        CONNECTION_STATE_CONN_FAILED,
                        CONNECTION_STATE_ERROR_OCCURED,
                        ])) && (
                            <div className="networkoffline">
                            {!isAppOnline
                            ? "Please check your Internet connection"
                            : capitalizeFirstLetter(
                            CONNECTION_STATE_CONNECTING.toLocaleLowerCase()
                            )}
                            </div>
                        )}
                        {loaderStatus && <div className="loader-container">
                            <img src={loaderSVG} alt="loader" style={loaderStyle} />
                        </div>}

                        {callLogArr.length > 0 &&
                            <ul className="chat-list-ul" id="scrollableUl-callLog">
                                <InfiniteScroll
                                    dataLength={callLogArr.length}
                                    next={fetchMoreData}
                                    hasMore={true}
                                    scrollableTarget="scrollableUl-callLog"
                                >
                                    {handleCallLogs()}
                                </InfiniteScroll>
                            </ul>
                        }

                        {callLogArr.length === 0 && searchterm === "" ?
                            <div className="norecent-chat">
                                <i className="norecent-chat-img">
                                    <EmptyCallLogHoc viewBox="0 0 148 143.189"/>
                                </i>
                                <h4>{"Oh snap It seems like they’re no call history!"}</h4>

                                <h3>Click on <i className="callAction"><FloatingCallActionSmHoc viewBox="0 0 24 24"/></i> or Search to start a Call!</h3>
                            </div>
                            :
                            <>
                                {callLogArr.length === 0 &&
                                    <div className="norecent-chat">
                                        <i className="norecent-chat-img">
                                            <EmptyCallLogHoc viewBox="0 0 148 143.189"/>
                                        </i>
                                        <h4>{"No call log history found"}</h4>
                                        <h3>{"Any new calls will appear here"}</h3>
                                    </div>
                                }
                            </>
                        }

                    </div>
                    <FloatingCallOption
                        handleAudioCall={handleAudioCall}
                        handleVideoCall={handleVideoCall}
                    />
                </React.Fragment>
                :
                <NewParticipants
                    newCallType={newCallType}
                    newCall={true}
                    handleBackToCallLog={handleBackCallLog}
                    handleMakeNewCall={makeNewcall}
                />
            }
        </React.Fragment>
    );
}

export default WebChatCallLogs;